/**
 * @file application.js
 */

(function($) {

	//require('./_initialize/_adjust-facebook-plugin-initialize')();

	require('./_initialize/_cta-button-initialize')();

	require('./_initialize/_drawer-menu-accordion-initialize')();

	require('./_initialize/_device-check-initialize')();

	require('./_initialize/_scroll-header-initialize')();

	require('./_initialize/_scroll-initialize')();

	require('./_initialize/_sp-menu-button-initialize')();

	require('./_initialize/_qa-accordion-initialize')();

	require('./_initialize/_related-post-adjust-initialize')();

	require('./_initialize/_menu-initialise')();

	require('./_initialize/_modal-initialize')();

	require('./_initialize/_validator-initialize')();

	require('./_initialize/_form-submit-initialize')();

})(jQuery);






